import request from './request.js'

// 赛事登录
export function login(data) {
	return request({
		url: '/match/login',
		method: 'post',
		data: data
	})
}

// 查询个人信息
export function getUserInfo() {
	return request({
		url: '/system/user/profile',
		method: 'get'
	})
}

// 查询个人资料
export function getPersonal() {
	return request({
		url: '/system/personal/detail',
		method: 'get'
	})
}

// 编辑个人资料
export function editPersonal(data) {
	return request({
		url: '/system/personal/userEdit',
		method: 'put',
		data: data
	})
}

// 查询荣誉列表
export function getHonourList(query) {
	return request({
		url: '/system/honour/user/list',
		method: 'get',
		params: query
	})
}
// 查询荣誉列表
export function selectHonourList(query) {
	return request({
		url: '/system/honour/select',
		method: 'get',
		params: query
	})
}

// 用户密码重置
export function updateUserPwd(oldPassword, newPassword) {
	const data = {
		oldPassword,
		newPassword
	}
	return request({
		url: '/system/user/profile/updatePwd',
		method: 'put',
		params: data
	})
}